import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './common/reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from './common/ErrorBoundary';
import PublicRoutes from './routes/public/index';
import PrivateRoutes from './routes/private/index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const rootElement = document.getElementById('root');
rootElement.style.width = '1000px';
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <PrivateRoutes />
        <PublicRoutes />
      </Router>
      {/* Unico contenitore dei toast: sopravvive ai cambi di pagina */}
      <ToastContainer />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
